// extracted by mini-css-extract-plugin
export default {"container":"_2nDB1","noSpacing":"_1r7bE","noSpacingTop":"_1AuiK"};